import checkStatus from './checkStatus';
import parseJSON from './parseJSON';

export default {
  checkStatus,
  parseJSON,
};



// WEBPACK FOOTER //
// ./app/utils/http/index.js